import React from 'react';
import PropTypes from 'prop-types';

export const PluginCarouselIcon = ({ small = false, ...rest }) => {
  if (small) {
    return (
      <svg
        width="57"
        height="25"
        viewBox="0 0 57 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M0.5 1H8.52C9.90071 1 11.02 2.11929 11.02 3.5V21.5C11.02 22.8807 9.90071 24 8.52 24H0.5V1Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M19.32 1H37.32C38.7007 1 39.82 2.11929 39.82 3.5V21.5C39.82 22.8807 38.7007 24 37.32 24H19.32C17.9393 24 16.82 22.8807 16.82 21.5V3.5C16.82 2.11929 17.9393 1 19.32 1Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M56.14 24H48.12C46.7393 24 45.62 22.8807 45.62 21.5V3.5C45.62 2.11929 46.7393 1 48.12 1H56.14V24Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
      </svg>
    );
  }

  return (
    <svg
      width="101"
      height="57"
      viewBox="0 0 101 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33325 0.5H16.7008C18.6338 0.5 20.2008 2.067 20.2008 4V52.9536C20.2008 54.8866 18.6338 56.4536 16.7008 56.4536H1.33325V0.5Z"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <path
        d="M84.9658 0.5H100.333V56.4536H84.9658C83.0328 56.4536 81.4658 54.8866 81.4658 52.9536V4C81.4658 2.067 83.0328 0.5 84.9658 0.5Z"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <rect
        x="27.1611"
        y="0.5"
        width="47.3444"
        height="55.9536"
        rx="3.5"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
    </svg>
  );
};

PluginCarouselIcon.propTypes = {
  small: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/PluginCarouselIcon.jsx